import {
  Tv, Music, Cloud, Dumbbell, Gamepad2, Sparkles, CreditCard, Landmark,
  Receipt, Zap, Wifi, Home, Shield, GraduationCap, Users, RefreshCw, Package,
} from "lucide-react";

export function formatINR(n, withDecimals = false) {
  if (n == null || isNaN(n)) return "₹0";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: withDecimals ? 2 : 0,
    minimumFractionDigits: 0,
  }).format(n);
}

export function formatDate(d) {
  if (!d) return "—";
  try {
    const date = new Date(d);
    return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return String(d);
  }
}

export function formatShortDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  } catch {
    return String(d);
  }
}

export const CATEGORIES = [
  { value: "subscription", label: "Subscription", icon: Tv },
  { value: "emi", label: "EMI", icon: CreditCard },
  { value: "bnpl", label: "BNPL", icon: Package },
  { value: "bill", label: "Recurring Bill", icon: Receipt },
  { value: "autopay", label: "Autopay / Mandate", icon: RefreshCw },
  { value: "shared", label: "Shared", icon: Users },
];

export const FREQUENCIES = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "half-yearly", label: "Half-yearly" },
  { value: "annual", label: "Annual" },
  { value: "one-time", label: "One-time future instalment" },
  { value: "custom", label: "Custom" },
];

export function categoryMeta(cat) {
  return CATEGORIES.find((c) => c.value === cat) || { value: cat, label: cat, icon: Landmark };
}

export function daysLabel(dr) {
  if (dr == null) return "No date";
  if (dr < 0) return `${Math.abs(dr)}d overdue`;
  if (dr === 0) return "Due today";
  if (dr === 1) return "in 1 day";
  return `in ${dr} days`;
}

export function ratioColor(ratio) {
  if (ratio < 30) return "#10B981";
  if (ratio < 50) return "#5EAD8C";
  if (ratio <= 70) return "#F4A261";
  return "#E07A5F";
}

export const STATUS_META = {
  active: { label: "Active", cls: "bg-calm-successbg text-calm-success" },
  paused: { label: "Paused", cls: "bg-calm-pendingbg text-calm-pending" },
  cancelled: { label: "Cancelled", cls: "bg-secondary text-muted-foreground" },
};
